var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { put, call, takeLatest } from 'redux-saga/effects';
import localStore from 'store';
import history from '@store/history';
import { checkWebConnection } from '@store/connection/actions';
import errorHandler from 'services/connection';
import { login as loginAction, loginComplete, logout as logoutAction, logoutComplete, } from './actions';
var getErrorBody = function (response) { return response.json(); };
// eslint-disable-next-line no-unused-vars
export function login(api, action) {
    var body, error_1, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 4, , 10]);
                return [4 /*yield*/, logout(api, api)];
            case 1:
                _b.sent();
                return [4 /*yield*/, call([api, api.post], 'login', action.payload)];
            case 2:
                body = (_b.sent()).body;
                localStore.set('currentUserId', body.assistantId);
                return [4 /*yield*/, put(loginComplete(body.assistantId))];
            case 3:
                _b.sent();
                history.push('/');
                return [3 /*break*/, 10];
            case 4:
                error_1 = _b.sent();
                if (!!Boolean(error_1.response)) return [3 /*break*/, 6];
                return [4 /*yield*/, put(checkWebConnection(loginAction, action.payload))];
            case 5:
                _b.sent();
                return [3 /*break*/, 9];
            case 6:
                // $FlowIgnoreNextLine
                _a = error_1;
                return [4 /*yield*/, call(getErrorBody, error_1.response)];
            case 7:
                // $FlowIgnoreNextLine
                _a.body = _b.sent();
                return [4 /*yield*/, put(loginComplete(error_1))];
            case 8:
                _b.sent();
                _b.label = 9;
            case 9: return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
export function logout(api, action) {
    var error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, call([api, api.post], 'logout', action.payload)];
            case 1:
                _a.sent();
                localStore.set('currentUserId', null);
                return [4 /*yield*/, put(logoutComplete())];
            case 2:
                _a.sent();
                history.push('/login');
                return [3 /*break*/, 5];
            case 3:
                error_2 = _a.sent();
                return [4 /*yield*/, put(errorHandler(error_2, logoutComplete, logoutAction, action.payload))];
            case 4:
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
export function loginWatcher(_a) {
    var api = _a.api;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, takeLatest('LOGIN', login, api)];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
export function logoutWatcher(_a) {
    var api = _a.api;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, takeLatest('LOGOUT', logout, api)];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
